import FingerprintJS from '@fingerprintjs/fingerprintjs'

let fpPromise: Promise<any> | null = null

/**
 * 获取浏览器指纹实例
 */
export const getFingerprintInstance = async () => {
    if (!fpPromise) {
        fpPromise = FingerprintJS.load()
    }
    return fpPromise
}

/**
 * 获取访客ID（浏览器指纹）
 */
export const getUUID = async (): Promise<string> => {
    try {
        const fp = await getFingerprintInstance()
        const result = await fp.get()
        return result.visitorId
    } catch (error) {
        console.error('获取访客ID失败:', error)
        // 返回一个基于时间戳的备用ID
        return `fallback_${Date.now()}_${Math.random().toString(36).substring(2, 8)}`
    }
}
